export const RECAPTCHA_ACH_TYPE = 'CHECKOUT_ACH';
export const RECAPTCHA_CARD_TYPE = 'CHECKOUT_CC';
export const RECAPTCHA_SEPA_TYPE = 'CHECKOUT_SEPA';
export const RECAPTCHA_BACS_TYPE = 'CHECKOUT_BACS';
export const RECAPTCHA_PADS_TYPE = 'CHECKOUT_PADS';
export const RECAPTCHA_AFFIRM_TYPE = 'CHECKOUT_AFFIRM';
export const RECAPTCHA_KLARNA_TYPE = 'CHECKOUT_KLARNA';